import { BannerContent } from "~/ui/hub-banner";

interface BannerPreviewProps {
  content: string;
}

export const BannerPreview = ({ content }: BannerPreviewProps) => {
  return <BannerContent content={content} className="rounded" />;
};
